<template>
  <div class="social-links-display" role="region">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-7 col-xs-12">
          <h1>Stay Connected with<br>Auto Dealer<br><strong>on <span id="default-social">...</span><span id="twitter-social">Twitter</span><span id="facebook-social">Facebook</span><span id="insta-social">Instagram</span><span id="youtube-social">YouTube</span></strong></h1>
        </div>
        <div class="col-xs-12 col-sm-5 col-md-6 col-lg-6 block-col">
          <a href="#">
            <div class="social-block" id="twitter-block">
              <i class="fa fa-twitter" aria-hidden="true"></i>
            </div>
          </a>
          <a href="#">
            <div class="social-block" id="facebook-block">
              <i class="fa fa-facebook" aria-hidden="true"></i>
            </div>
          </a>
          <a href="#">
            <div class="social-block" id="insta-block">
              <i class="fa fa-instagram" aria-hidden="true"></i>
            </div>
          </a>
          <a href="#">
            <div class="social-block" id="youtube-block">
              <i class="fa fa-youtube" aria-hidden="true"></i>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      brand: this.$store.state.chosenBrand
    }
  },
  computed: {
    brandName () {
      if (this.brand === 'none') {
        return 'Brand';
      } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
        return this.brand.toUpperCase();
      } else {
        return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
      }
    }
  },
  mounted() {
    (function () {
      var socialHover = {
        init: function () {

          $(".social-links-display #twitter-block").hover(function () {
              $(".social-links-display h1").css("color", "#00abf0");
              $(".social-links-display #default-social").css("display", "none");
              $(".social-links-display #twitter-social").css("display", "inline-block");
          }, function () {
              $(".social-links-display h1").css("color", "#333");
              $(".social-links-display #default-social").css("display", "inline-block");
              $(".social-links-display #twitter-social").css("display", "none");
          });

          $(".social-links-display #facebook-block").hover(function () {
              $(".social-links-display h1").css("color", "#39579a");
              $(".social-links-display #default-social").css("display", "none");
              $(".social-links-display #facebook-social").css("display", "inline-block");
          }, function () {
              $(".social-links-display h1").css("color", "#333");
              $(".social-links-display #default-social").css("display", "inline-block");
              $(".social-links-display #facebook-social").css("display", "none");
          });

          $(".social-links-display #insta-block").hover(function () {
              $(".social-links-display h1").css("color", "#4f7ea6");
              $(".social-links-display #default-social").css("display", "none");
              $(".social-links-display #insta-social").css("display", "inline-block");
          }, function () {
              $(".social-links-display h1").css("color", "#333");
              $(".social-links-display #default-social").css("display", "inline-block");
              $(".social-links-display #insta-social").css("display", "none");
          });

          $(".social-links-display #youtube-block").hover(function () {
              $(".social-links-display h1").css("color", "#bd0000");
              $(".social-links-display #default-social").css("display", "none");
              $(".social-links-display #youtube-social").css("display", "inline-block");
          }, function () {
              $(".social-links-display h1").css("color", "#333");
              $(".social-links-display #default-social").css("display", "inline-block");
              $(".social-links-display #youtube-social").css("display", "none");
          });
        }
      }

      $(document).ready(socialHover.init);
    })(jQuery);
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
  .social-links-display {
    background: #fff;
    padding: 40px 0;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }
  .social-links-display h1 {
    text-transform: uppercase;
    font-weight: 300;
    color: #333;
  }
  .social-links-display strong {
    font-weight: 400;
  }
  .social-links-display #twitter-social {
    display: none;
  }
  .social-links-display #facebook-social {
    display: none;
  }
  .social-links-display #insta-social {
    display: none;
  }
  .social-links-display #google-social {
    display: none;
  }
  .social-links-display #youtube-social {
    display: none;
  }
  .social-links-display .social-block {
    height: 100px;
    width: 100px;
    margin: 20px 2px 2px 2px;
    color: #fff !important;
    font-size: 30px;
    padding-top: 30px;
    text-align: center;
    background: var(--primary-color);
    display: inline-block;
    -moz-transition: all 300ms ease-out;
    -webkit-transition: all 300ms ease-out;
    -o-transition: all 300ms ease-out;
    transition: all 300ms ease-out;
  }
  .social-links-display a {
    color: #fff !important;
    text-decoration: none !important;
  }
  .social-links-display #twitter-block:hover {
    background: #00abf0;
  }
  .social-links-display #facebook-block:hover {
    background: #39579a;
  }
  .social-links-display #insta-block:hover {
    background: #4f7ea6;
  }
  .social-links-display #youtube-block:hover {
    background: #bd0000;
  }

  @media (min-width: 1270px) {
    .social-links-display h1 {
      float: right;
      margin-right: 30px;
    }
  }

  @media (max-width: 991px) and (min-width: 379px) {
    .social-links-display .social-block {
      height: 60px;
      width: 60px;
      padding-top: 20px;
      font-size: 20px;
    }
  }

  @media (max-width: 400px) {
    .social-links-display .social-block {
      height: 50px;
      width: 50px;
      padding-top: 15px;
      font-size: 20px;
    }
  }
</style>